/**
 * Desplaza el scroll al elemento con el id proporcionado.
 * @param {string} elementId - El id del elemento al que se desea desplazar.
 * @param {string} behavior - El comportamiento del scroll ("auto" o "smooth").
 */
export const scrollToElement = (elementId, behavior = 'smooth') => {
  const element = document.getElementById(elementId)
  if (element) {
    element.scrollIntoView({ behavior })
  }
}

/**
 * Desplaza el scroll al final de la página.
 */
export const scrollToBottom = () => {
  window.scrollTo(0, document.body.scrollHeight)
}